import axios from 'axios';
import moment from 'moment';
import utils from '../store/fuse/utils';

const API_URL = process.env.REACT_APP_API_URL;

const { formatDates } = utils;

export async function getNodeMetrics(nodeId, filters) {
  try {
    const requestBody = {
      grupoInmuebleId: filters?.grupo || 0,
      inmuebleId: filters?.inmueble || 0,
      regionId: filters?.region || 0,
      fechaFin: filters?.fechaFin || moment().format('Y-MM-DD HH:mm:00'),
      fechaIni: filters?.fechaIni || moment().subtract(24, 'hour').format('Y-MM-DD HH:mm:00'),
      nodeId: nodeId || filters?.nodo || 0,
      metricaId: 0,
      amarillo: false,
      gris: false,
      verde: false,
      rojo: false,
      tipoInmuebleId: 0,
    };

    // Ejecutar todas las llamadas en paralelo
    const [responseMetricas, responseAnchoBanda, responseMetricsInt] = await Promise.all([
      axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/getMetricas`, requestBody),
      axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/metricas/anchoBanda`, requestBody),
      axios.post(`${API_URL}/ms-dashboard/tablero/indicadores/getMetricasByInterface`, requestBody),
    ]);

    // Procesar datos de responseMetricas
    const metricasData = responseMetricas.data.data;
    const metricasObj = {};
    if (metricasData) {
      metricasObj[1] = [];
      metricasObj[2] = [];
      metricasObj[10] = [];
      metricasObj[4] = [];
      metricasObj[5] = [];

      metricasData.forEach((node) => {
        metricasObj[1].push({ dslectura1: Number(node?.memoria || 0).toFixed(3), fecha: moment(node.fecha) });
        metricasObj[2].push({ dslectura1: Number(node?.cpu || 0).toFixed(3), fecha: moment(node.fecha) });
        metricasObj[10].push({ dslectura1: Number(node?.disponibilidad || 0).toFixed(3), fecha: moment(node.fecha) });
        metricasObj[4].push({ dslectura1: Number(node?.latencia || 0).toFixed(3), fecha: moment(node.fecha) });
        metricasObj[5].push({ dslectura1: Number(node?.porcenloss || 0).toFixed(3), fecha: moment(node.fecha) });
      });
    }
    // Ordenar y formatear las fechas de metricasObj
    if (Object.keys(metricasObj).length > 0) {
      Object.keys(metricasObj).forEach((metricId) => {
        metricasObj[metricId] = metricasObj[metricId].sort((a, b) => a.fecha.diff(b.fecha));
        metricasObj[metricId] = metricasObj[metricId].map((metricRegister) => ({
          ...metricRegister,
          fecha: formatDates(metricRegister.fecha),
        }));
      });
    }

    // Procesar datos de responseAnchoBanda
    const anchoBandaData = responseAnchoBanda.data.data;
    const anchoBandaObj = {};
    const interfaces = [];
    const existingInterfaces = new Set();

    if (anchoBandaData) {
      anchoBandaData.forEach((node) => {
        if (!anchoBandaObj[node.interfaceid]) anchoBandaObj[node.interfaceid] = [];
        anchoBandaObj[node.interfaceid].push({
          ...node,
          fecha: moment(node.fechaOrigen),
          dslectura1: Number(node.anchobandasubida).toFixed(2),
          dslectura2: Number(node.anchobandabajada).toFixed(2),
        });
        if (!existingInterfaces.has(node.interfaceid)) {
          interfaces.push({ value: node.interfaceid, label: node.dsinterface });
          existingInterfaces.add(node.interfaceid);
        }
      });
    }
    // Ordenar y formatear las fechas de anchoBandaObj
    if (Object.keys(anchoBandaObj).length > 0) {
      Object.keys(anchoBandaObj).forEach((interfaceid) => {
        anchoBandaObj[interfaceid] = anchoBandaObj[interfaceid].sort((a, b) => a.fecha.diff(b.fecha)).map((metricRegister) => ({
          ...metricRegister,
          fecha: formatDates(metricRegister.fecha),
        }));
      });
    }

    // Procesar datos de responseMetricsInt
    const metricsInterfaceData = responseMetricsInt.data.data;
    const metricsInterfaceDataObj = {};
    const metricsErrorInterfaceDataObj = {};
    const metricsDescInterfaceDataObj = {};

    if (metricsInterfaceData) {
      metricsInterfaceData.forEach((node) => {
        if (!metricsInterfaceDataObj[node.interfaceid]) metricsInterfaceDataObj[node.interfaceid] = [];
        metricsInterfaceDataObj[node.interfaceid].push({
          ...node,
          fecha: moment(node.fecha),
          dslectura1: Number(node.bandwidthin).toFixed(2),
          dslectura2: Number(node.bandwidthout).toFixed(2),
        });
        if (!metricsErrorInterfaceDataObj[node.interfaceid]) metricsErrorInterfaceDataObj[node.interfaceid] = [];
        metricsErrorInterfaceDataObj[node.interfaceid].push({
          ...node,
          fecha: moment(node.fecha),
          dslectura1: Number(node.errorin).toFixed(2),
          dslectura2: Number(node.errorout).toFixed(2),
        });
        if (!metricsDescInterfaceDataObj[node.interfaceid]) metricsDescInterfaceDataObj[node.interfaceid] = [];
        metricsDescInterfaceDataObj[node.interfaceid].push({
          ...node,
          fecha: moment(node.fecha),
          dslectura1: Number(node.discardsin).toFixed(2),
          dslectura2: Number(node.discardsout).toFixed(2),
        });
        if (!existingInterfaces.has(node.interfaceid)) {
          interfaces.push({ value: node.interfaceid || node.dsinterface, label: node.dsinterface });
          existingInterfaces.add(node.interfaceid);
        }
      });
    }
    // Ordenar y formatear las fechas de metricsInterfaceDataObj
    if (Object.keys(metricsInterfaceDataObj).length > 0) {
      Object.keys(metricsInterfaceDataObj).forEach((interfaceid) => {
        metricsInterfaceDataObj[interfaceid] = metricsInterfaceDataObj[interfaceid].sort((a, b) => a.fecha.diff(b.fecha))
          .map((metricRegister) => ({
          ...metricRegister,
          fecha: formatDates(metricRegister.fecha),
        }));
      });
    }

    return {
      nodeInterfaces: interfaces,
      metricasGraphicData: metricasObj,
      anchoBandaGraphicData: anchoBandaObj,
      metricsInterfaceData: metricsInterfaceDataObj,
      metricsErrorInterfaceData: metricsErrorInterfaceDataObj,
      metricsDescInterfaceData: metricsDescInterfaceDataObj
    };
  } catch (error) {
    return 'Error found when fetching data';
  }
};

const formatNumberValue = (value) => {
  if (Number.isNaN(Number(value))) {
    return 0;
  }
  return Math.floor(Number(value));
};

export async function getGraphicMetrics(equipment, metric) {
  try {
    const response = await axios.get(`/anchodebanda/`);
    let responseData = await response.data.data;
    // responseData = responseData.map((data, index) => ({ ...data, id: index + 1 }));
    responseData = responseData.map((data) => ({
      ...data,
      dslectura1: formatNumberValue(data.dslectura1),
      dslectura2: formatNumberValue(data.dslectura2),
      fechacreacion: moment(data.fechacreacion).format('Y-MM-DD HH:mm'),
    }));
    return responseData;
  } catch (error) {
    return 'Error found when fetching data';
  }
};